import React from 'react';
import { Link } from 'react-router-dom';

// ancestors: root-first array of { _id, name, slug } (from useCategory's
// `ancestors` field). current: the resolved category itself ({ name }, not
// linked). On narrow viewports, middle ancestors collapse behind an ellipsis
// (CSS-driven, see .ss-breadcrumbs__crumb--collapsible in storefront.css) —
// the first and last ancestor plus Home/current stay visible at every width.
export default function Breadcrumbs({ ancestors = [], current }) {
  if (!current) return null;

  const hasCollapsible = ancestors.length > 2;

  return (
    <nav className="ss-breadcrumbs" aria-label="Breadcrumb">
      <ol>
        <li>
          <Link to="/products">Home</Link>
        </li>
        {ancestors.map((ancestor, i) => {
          const isMiddle = hasCollapsible && i > 0 && i < ancestors.length - 1;
          const path = `/category/${ancestors
            .slice(0, i + 1)
            .map((a) => a.slug)
            .join('/')}`;
          return (
            <React.Fragment key={ancestor._id}>
              {i === ancestors.length - 1 && hasCollapsible && (
                <li className="ss-breadcrumbs__ellipsis" aria-hidden="true">
                  &hellip;
                </li>
              )}
              <li className={isMiddle ? 'ss-breadcrumbs__crumb--collapsible' : undefined}>
                <Link to={path}>{ancestor.name}</Link>
              </li>
            </React.Fragment>
          );
        })}
        <li className="ss-breadcrumbs__current" aria-current="page">
          {current.name}
        </li>
      </ol>
    </nav>
  );
}
